import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/energy-source-prices')({
  beforeLoad: ({ context, params }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('energy-sources-price:list')) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/territories/pages/territory-energy-source-prices-page').then((m) => ({
      default: m.default,
    })),
  ),
  staticData: { titleKey: 'energySourcePrices' },
});
